import React, { useEffect, useRef } from "react";
import "./TextContainer.css";
import clsx from "clsx";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { usePreloader } from "../contexts/PreloaderContext";

gsap.registerPlugin(ScrollTrigger);

export type TextContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  skipOpacityAnimation?: boolean;
};

export function TextContainer({
  children,
  className,
  skipOpacityAnimation = false,
  ...rest
}: TextContainerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isComplete } = usePreloader();

  useEffect(() => {
    if (containerRef.current && !skipOpacityAnimation && isComplete) {
      gsap.fromTo(
        containerRef.current,
        { opacity: 0.4 },
        {
          opacity: 1,
          ease: "none",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 65%",
            end: "top 45%",
            scrub: true,
          },
        },
      );
    }
  }, [skipOpacityAnimation, isComplete]);

  return (
    <div
      className={clsx("text-container", className)}
      ref={containerRef}
      {...rest}
      style={{
        opacity: skipOpacityAnimation ? undefined : 0,
      }}
    >
      {children}
    </div>
  );
}
